import { render } from "./CustomButtonComponent.vue?vue&type=template&id=bf4c440a"
import script from "./CustomButtonComponent.vue?vue&type=script&lang=js"
export * from "./CustomButtonComponent.vue?vue&type=script&lang=js"

import "./CustomButtonComponent.vue?vue&type=style&index=0&id=bf4c440a&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__